var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNouser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "28px",
    viewBox: "0 0 34 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "12F00B6C-9339-47A0-B919-41807A6FA2C9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-OV-CECEU---Desktop-CAMBIOS-ENE21",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Acceder-no-user",
    transform: "translate(-666.000000, -432.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(297.000000, 384.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(369.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(3.000000, 1.000000)",
    stroke: "#333333",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6363636,21.2727273 C4.76154545,21.2727273 0,16.5111818 0,10.6363636 C0,4.76154545 4.76154545,0 10.6363636,0 C15.6980909,0 19.9349091,3.536 21.0091818,8.27272727",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1818182,8.27272727 C14.1818182,10.231 12.5946364,11.8181818 10.6363636,11.8181818 C8.67809091,11.8181818 7.09090909,10.231 7.09090909,8.27272727 C7.09090909,6.31445455 8.67809091,4.72727273 10.6363636,4.72727273 C12.5946364,4.72727273 14.1818182,6.31445455 14.1818182,8.27272727 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.54545455,18.9090909 C3.54545455,14.9937273 6.721,11.8181818 10.6363636,11.8181818 C11.9273313,11.8181818 13.3486569,12.0317889 14.180745,12.7660654",
    id: "Stroke-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(16.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E2573C",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(5.000000, 5.000000)",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 4.87229305e-14,
    y1: -2.43614652e-14,
    x2: 5.45482374,
    y2: 5.45482374,
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.87229305e-14,
    y1: -2.43614652e-14,
    x2: 5.45482374,
    y2: 5.45482374,
    id: "Line-2-Copy",
    transform: "translate(2.727412, 2.727412) scale(1, -1) translate(-2.727412, -2.727412) "
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNouser);
export default __webpack_public_path__ + "static/media/nouser.f3018f98.svg";
export { ForwardRef as ReactComponent };